<template>
  <div v-if="investment">
    <TheHeader
      back-route="."
      with-menu
    />
    <BaseSection class="mb-8">
      <BaseTitleGroup
        :subtitle="`${$t('My investments')} / ${participation.attributes.name}`"
        :title="$t('Investments')"
      />
    </BaseSection>
    <BaseSection class="mb-4">
      <InvestmentDetailsContent />
    </BaseSection>
  </div>
</template>

<script>
import loadInvestment from '../mixins/loadInvestment';
import TheHeader from '../components/TheHeader.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseSectionHeader from '../components/BaseSectionHeader.vue';
import BaseParagraph from '../components/BaseParagraph.vue';
import BaseLabelledInfo from '../components/BaseLabelledInfo.vue';
import BaseCurrencySpan from '../components/BaseCurrencySpan.vue';
import InvestmentDetailsContent from './partials/InvestmentDetailsContent.vue';

export default {
  name: 'InvestmentDetails',
  components: {
    TheHeader,
    BaseTitleGroup,
    BaseSection,
    BaseSectionHeader,
    BaseParagraph,
    BaseLabelledInfo,
    BaseCurrencySpan,
    InvestmentDetailsContent,
  },
  mixins: [loadInvestment],
  computed: {
    heldPercentage() {
      return (this.participationDetails.sharesHeld / this.participationDetails.totalShares) * 100;
    },
  },
};
</script>
